import React, { useState } from 'react';
import '../custom.css';
import { Document, Page } from 'react-pdf'
import i18n from 'i18next';

const RenderAcceptButton = (props) => {
    return (
        <div className="d-flex flex-row mt-auto justify-content-end">
            <div>
                <button className={"}finish-action-btn button " + (props.acceptable ? "button-red" : "button-grey")} onClick={props.acceptAgreement}>
                    {props.acceptable ? i18n.t('accept') : i18n.t('close')}
                </button>
            </div>
        </div>
    );
}

const AgreementPopup = (props) => {
    const [numPages, setNumPages] = useState(0);

    return (
        <div className='popup'>
            <div className='popup-open-agreement d-flex flex-column'>
                <div className="d-flex flex-row justify-content-between" style={{ marginBottom: "30px" }}>
                    <div className="popup-header">
                    {i18n.t('accept regulations')}
                    </div>
                </div>

                <div className="popup-content d-flex flex-column">
                    <Document
                        file={`data:application/pdf;base64,${props.agreement}`}
                        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    >
                        {Array.from({ length: numPages }, (_, index) => (
                            <Page
                                key={index + 1}
                                pageNumber={index + 1}
                                width={1100}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                            />
                        ))}
                    </Document>
                </div>
                {RenderAcceptButton(props)}
            </div>
        </div>
    );
}

export default AgreementPopup;